import React from 'react'
import { Button } from 'reactstrap'
import { firstLetter } from 'common'
import ReactHtmlParser from 'react-html-parser'
import useTranslation from '../hooks/UseTranslation'
import GuruModal from './GuruModal'
import AsyncButton from './AsyncButton'

const DeleteModal = (props) => {
  const { t } = useTranslation()
  const [disabled, setDisabled] = React.useState(props.disabled)

  React.useEffect(() => setDisabled(props.disabled), [props.disabled])

  return (
    <GuruModal
      isOpen={props.isOpen}
      toggle={props.toggle}
      title={firstLetter(props.title ?? t('delete'))}
      button={
        <>
          <Button disabled={disabled} color='light' onClick={props.toggle}>
            {t('cancel')}
          </Button>{' '}
          <AsyncButton
            disabled={disabled}
            color='secondary'
            onClick={props.delete}
          >
            {t('delete')}
          </AsyncButton>
        </>
      }
    >
      {props.content && <p>{ReactHtmlParser(props.content)}</p>}
      <p>{t('are_you_sure')}</p>
    </GuruModal>
  )
}
export default DeleteModal
